export default __webpack_public_path__ + "static/media/brand-icons.d68fa3e6.eot";